import { useEffect } from "react";

export const clearActiveElementFocus = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const activeElement = document.activeElement;
      if (
        activeElement instanceof HTMLElement &&
        activeElement !== document.body
      ) {
        activeElement.blur();
      }
    });
  });
};

const getOpenDialogCount = () => {
  if (typeof document === "undefined") {
    return 0;
  }

  return document.querySelectorAll('[role="dialog"], [role="alertdialog"]')
    .length;
};

export const useClearFocusAfterDialogClose = () => {
  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }

    let previousOpenDialogCount = getOpenDialogCount();

    const observer = new MutationObserver(() => {
      const nextOpenDialogCount = getOpenDialogCount();

      if (previousOpenDialogCount > 0 && nextOpenDialogCount === 0) {
        clearActiveElementFocus();
      }

      previousOpenDialogCount = nextOpenDialogCount;
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class", "hidden", "aria-hidden"],
    });

    return () => observer.disconnect();
  }, []);
};
